import { useContext, useState } from "react";
import AuthContainer from "../../components/authContainer/authContainer";
import NewPasswordForm from "../../components/forgotPassword/newPasswordForm/newPasswordForm";
import VerificationCodeForm from "../../components/forgotPassword/verificationCodeForm/verificationCodeForm";
import { FORGOT_PASSWORD_STEPS } from "../../data/constants";
import EmailForm from "./../../components/forgotPassword/emailForm/emailForm";
import SuccessResetPassword from "./../../components/forgotPassword/successResetPassword/successResetPassword";
import { ForgotPasswordContext } from "./../../context/forgotPasswordContext";

const { EMAIL_FORM_STEP, VERIFICATION_CODE_FORM_STEP, NEW_PASSWORD_FORM_STEP } =
    FORGOT_PASSWORD_STEPS;

const ForgotPasswordPage = () => {
    const { currentStep } = useContext(ForgotPasswordContext);
   

    return (
        <AuthContainer>
            {currentStep === EMAIL_FORM_STEP ? (
                <EmailForm />
            ) : currentStep === VERIFICATION_CODE_FORM_STEP ? (
                <VerificationCodeForm />
            ) : currentStep === NEW_PASSWORD_FORM_STEP ? (
                <NewPasswordForm  />
            ) : (
                <SuccessResetPassword />
            )}
        </AuthContainer>
    );
};

export default ForgotPasswordPage;
